/* Register LexIQ PWA service worker — required for offline shell AND for Web
   Push notifications. Skipped on http:// (browsers reject SW without secure
   context except localhost).

   Auto-update strategy:
   - check for a new SW every page load (`reg.update()` after registration).
   - when a new worker is found, `controllerchange` fires once it activates →
     reload the page so the user sees fresh JS/CSS immediately instead of
     stale assets cached during a previous visit. */
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  const isSecure = window.isSecureContext || window.location.hostname === "localhost";
  if (!isSecure) return;

  // Reload the page once when the active worker is replaced — guarantees the
  // running app code matches the SW that just finished installing.
  let reloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloaded) return;
    reloaded = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // eslint-disable-next-line no-console
        console.log("[LexIQ] service worker registered:", reg.scope);
        // Force an immediate update check so users on stale caches pick up
        // newly deployed code without waiting for the browser's own timer.
        reg.update().catch(() => {});
        // If a waiting worker exists, tell it to take over now (it normally
        // waits for all tabs to close).
        if (reg.waiting) {
          reg.waiting.postMessage({ type: "SKIP_WAITING" });
        }
        reg.addEventListener("updatefound", () => {
          const sw = reg.installing;
          if (!sw) return;
          sw.addEventListener("statechange", () => {
            if (sw.state === "installed" && navigator.serviceWorker.controller) {
              sw.postMessage({ type: "SKIP_WAITING" });
            }
          });
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn("[LexIQ] SW registration failed:", err);
      });
  });
}
